<template>
  <div>
    <b-card title="Jóváhagyásra váró váró rekordfogások" v-if="$acl.canListPermission('record_catch')">
      <b-row>
        <b-col md="12">
          <b-alert v-if="waitingRecordCatches > 0"
                   variant="warning"
                   class="mb-2"
                   :show="true"
          >
            <div class="alert-body">
              <feather-icon
                  icon="AlertTriangleIcon"
                  class="mr-50"
              />
              Jelenleg <strong>{{ waitingRecordCatches }} db</strong> rekordfogás vár jóváhagyásra. <br>
              <b-button
                  class="mt-2"
                  size="sm"
                  variant="warning"
                  @click.stop="$router.push({ name: 'record-catches', query: {onlyTodo: 'true'}})"
              >Tovább
              </b-button>
            </div>
          </b-alert>
          <b-alert v-else
                   variant="success"
                   class="mb-2"
                   :show="true"
          >
            <div class="alert-body">
              <feather-icon
                  icon="AlertTriangleIcon"
                  class="mr-50"
              />
              Jelenleg nincs admin jóváhagyásra váró rekordfogás.<br>
              <b-button
                  class="mt-2"
                  size="sm"
                  variant="success"
                  @click.stop="$router.push({ name: 'record-catches'})"
              >Tovább
              </b-button>
            </div>
          </b-alert>
        </b-col>
      </b-row>
    </b-card>

    <b-card title="Naponkénti összesítő diagram" v-if="$acl.canListPermission('record_catch')">
      <b-row>
        <b-col md="12">
          <b-overlay
              :show="recordCatchLoading"
              spinner-variant="primary"
              spinner-type="grow"
              rounded="sm"
          >
            <chart-js-component-bar-chart
                ref="recordCatchChart"
                :height="400"
                :data="recordCatch.stackedChart.data"
                :options="recordCatch.stackedChart.options"
                :plugins="recordCatch.stackedChart.plugins"
            />
          </b-overlay>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {BCol, BRow, BCard, BCardText, BLink, BButton, BAlert, BOverlay} from 'bootstrap-vue'
import ChartJsComponentBarChart from '@/views/pages/_components/_dashboard/BarChart.vue'
import {$themeColors} from "@themeConfig";

export default {
  components: {
    BCol,
    BRow,
    BCard,
    BCardText,
    BLink,
    BButton,
    BAlert,
    BOverlay,
    ChartJsComponentBarChart
  },
  data() {
    const chartColors = {
      successColor: '#28c76f',
      warningColor: '#ff9f43',
      dangerColor: '#ea5455',
      secondaryColor: '#82868b',
      infoColor: '#00cfe8',
      tooltipShadow: 'rgba(0, 0, 0, 0.25)',
      labelColor: '#6e6b7b',
      gridLineColor: 'rgba(200, 200, 200, 0.2)',
    }

    return {
      chartColors: chartColors,
      recordCatchLoading: false,
      waitingRecordCatches: 0,
      recordCatch: {
        statuses: {
          waiting: 0,
          visible: 0,
        },
        stackedChart: {
          data: {
            labels: [],
            datasets: [
              {
                data: [],
                label: 'Jóváhagyásra vár',
                backgroundColor: chartColors.dangerColor,
                borderColor: 'transparent',
              },
              {
                data: [],
                label: 'Látható',
                backgroundColor: chartColors.successColor,
                borderColor: 'transparent',
              },
            ],
          },
          options: {
            elements: {
              rectangle: {
                borderWidth: 2,
                borderSkipped: 'bottom',
              },
            },
            hover: {
              mode: 'label',
            },
            responsive: true,
            maintainAspectRatio: false,
            responsiveAnimationDuration: 500,
            legend: {
              display: true,
              position: 'top',
              align: 'start',
              labels: {
                usePointStyle: true,
                padding: 25,
                boxWidth: 9,
              },
            },
            tooltips: {
              // Updated default tooltip UI
              shadowOffsetX: 1,
              shadowOffsetY: 1,
              shadowBlur: 8,
              shadowColor: chartColors.tooltipShadow,
              backgroundColor: $themeColors.light,
              titleFontColor: $themeColors.dark,
              bodyFontColor: $themeColors.dark,
            },
            scales: {
              xAxes: [
                {
                  display: true,
                  stacked: true,
                  gridLines: {
                    display: true,
                    color: chartColors.gridLineColor,
                    zeroLineColor: chartColors.gridLineColor,
                  },
                  scaleLabel: {
                    display: false,
                  },
                  ticks: {
                    fontColor: chartColors.labelColor,
                  },
                },
              ],
              yAxes: [
                {
                  display: true,
                  stacked: true,
                  scaleLabel: {
                    display: true,
                  },
                  gridLines: {
                    color: chartColors.gridLineColor,
                    zeroLineColor: chartColors.gridLineColor,
                  },
                  ticks: {
                    stepSize: 1,
                    min: 0,
                    max: 0,
                    fontColor: chartColors.labelColor,
                  },
                },
              ],
            },
          },
          plugins: [
            // to add spacing between legends and chart
            {
              beforeInit(chart) {
                /* eslint-disable func-names, no-param-reassign */
                chart.legend.afterFit = function () {
                  this.height += 20
                }
                /* eslint-enable */
              },
            },
          ],
        }
      },
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {

      this.recordCatchLoading = true

      this.recordCatch.stackedChart.data.labels = []
      this.recordCatch.statuses.waiting = 0
      this.recordCatch.statuses.visible = 0

      this.waitingRecordCatches = 0

      this.recordCatch.stackedChart.data.datasets[0].data = []
      this.recordCatch.stackedChart.data.datasets[1].data = []

      this.$store.dispatch('fetchDashboard').then(response => {

        this.waitingRecordCatches = response.data.waitingRecordCatches

        Object.keys(response.data.recordCatch).forEach(key => {
          this.recordCatch.stackedChart.data.labels.push(key)
          this.recordCatch.stackedChart.data.datasets[0].data.push(response.data.recordCatch[key].waiting)
          this.recordCatch.stackedChart.data.datasets[1].data.push(response.data.recordCatch[key].visible)

          this.recordCatch.statuses.waiting += response.data.recordCatch[key].waiting
          this.recordCatch.statuses.visible += response.data.recordCatch[key].visible

          let min = 0
          let max = 0

          Object.keys(this.recordCatch.statuses).forEach(key => {
            if (key !== 'waiting') {
              max += this.recordCatch.statuses[key]
            } else {
              min += this.recordCatch.statuses[key]
            }
          })

          this.recordCatch.stackedChart.options.scales.yAxes[0].ticks.min = -1 * min
          this.recordCatch.stackedChart.options.scales.yAxes[0].ticks.max = max
        })

        this.$refs.recordCatchChart.updateChart()
        this.recordCatchLoading = false
      })
    },
  }
}
</script>

<style>

</style>
